import { render, staticRenderFns } from "./SectionDetail.vue?vue&type=template&id=e86e72e4&scoped=true"
import script from "./SectionDetail.vue?vue&type=script&lang=js"
export * from "./SectionDetail.vue?vue&type=script&lang=js"
import style0 from "./SectionDetail.vue?vue&type=style&index=0&id=e86e72e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86e72e4",
  null
  
)

export default component.exports